import React, { FC } from 'react';
import cn from 'classnames';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import { FiRefreshCcw } from 'react-icons/fi';
import DownloadButton from 'components/UI/Buttons/DownloadButton';
import css from '../../styles.module.scss';
import CompositeFilter from '../CompositeFilter';
import { useHeader } from './hooks/useHeader';
import { THeaderProprs } from './types';

const Header: FC<THeaderProprs> = ({
  formik,
  groupings,
  filterings,
  objections,
  statistics,
  currentUserStep,
  columns,
  isGlobalLoading,
  setObjections,
  emptyFilter,
  resetForm
}) => {
  const { t, isThemeExtended, isThemeFull, handleDownload, isFiltersLoading } =
    useHeader(formik, columns);
  const disableApplyButton =
    !formik.values.reportFilters.objectionBy.client ||
    !Object.values(formik.values.reportFilters.statisticBy).some(
      (value) => value === true,
    ) ||
    isGlobalLoading;

  return (
    <div className={cn(css.header)}>
      <div
        className={cn('container resized', {
          extend: isThemeExtended,
          full: isThemeFull,
        })}
      >
        <h1 className={css.title}>{t(`reportbuilder.title`)}</h1>
        <div className={css.actions}>
          <TooltipPoratal
            hint={t(`update_btn`)}
            classname={css.actions_btn}
            white
            onClick={() => {
              if (disableApplyButton) return;
              formik.submitForm();
            }}
            isDisabled={disableApplyButton}
          >
            <FiRefreshCcw size={22} />
          </TooltipPoratal>
          <CompositeFilter
            formik={formik}
            groupings={groupings}
            filterings={filterings}
            objections={objections}
            statistics={statistics}
            currentUserStep={currentUserStep}
            isLoading={isFiltersLoading}
            isGlobalLoading={isGlobalLoading}
            setObjections={setObjections}
            emptyFilter={emptyFilter}
            resetForm={resetForm}
          />
          <DownloadButton
            onClick={() => handleDownload()}
            classname={css.actions_btn}
            disabled={isFiltersLoading || !columns.length || emptyFilter}
          />
        </div>
      </div>
    </div>
  );
};

export default React.memo(Header);
